<template>
  <v-select
    label="Client Status"
    :outlined="outlined"
    :items="items"
    item-text="name"
    item-value="id"
    v-model="selectedClientStatus"
    @change="onChange"
    :clearable="clearable"
  ></v-select>
</template>

<script>
import { removeGQLTypename } from "../../../helpers";
import { ALL_CLIENT_STATUSES_SEARCH_QUERY } from "../../../constants/graphql";
export default {
  name: "client-status-list-select",

  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    clearable: {
      type: Boolean,
      default: () => true,
    },
  },

  data() {
    return {
      selectedClientStatus: this.value ? this.value : null,
    };
  },
  computed: {
    items() {
      return this.clientStatuses && this.clientStatuses.edges
        ? this.clientStatuses.edges.map(removeGQLTypename)
        : [];
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.selectedClientStatus = newVal;
      }
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.selectedClientStatus);
    },
  },

  apollo: {
    clientStatuses: {
      query: ALL_CLIENT_STATUSES_SEARCH_QUERY,
      variables() {
        return {
          filter: {
            not_in_use_eq: false,
          },
        };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/ClientStatusListSelect.vue